package co.maytes.standupbot.dashboard.components.layout

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import co.maytes.standupbot.dashboard.stores.rememberAuthStore
import co.maytes.standupbot.shared.dto.auth.RoleDto
import com.varabyte.kobweb.core.rememberPageContext

@Composable
fun AdminGuard(content: @Composable () -> Unit) {
    val auth = rememberAuthStore()
    val ctx = rememberPageContext()
    val role = auth.currentUser?.role
    val isAdmin = role == RoleDto.OWNER || role == RoleDto.ADMIN

    LaunchedEffect(isAdmin) {
        if (auth.currentUser != null && !isAdmin) {
            ctx.router.navigateTo("/app")
        }
    }

    if (isAdmin) content()
}
